module.exports = __webpack_public_path__ + "img/dizuo.prt.d6db59ee.jpg";